/* @flow */
const pubSub = require('./pubsub');
const addRoute = ((document.getElementById('add-route'): any): HTMLInputElement);
const toggleRoutes = ((document.getElementById('toggle-routes'): any): HTMLInputElement);
function toggle() {
    if (toggleRoutes.checked) {
        addRoute.style.display = "block";
    } else {
        addRoute.style.display = "";
    }
}
// toggleRoutes.onclick = toggle;

// pubSub.subscribe('measure:finish', )

const API_KEY = 'Hr9nWC9kXQGkxtrakJBYKheiZMnZ7YsMDvxG8Ly6mlc';
export function init(props) {
    // addRoute.onclick = () => props.setMapMode('route');
}
